import { c as _c } from "react/compiler-runtime";
import { type RefObject, useCallback, useEffect, useRef, useState } from 'react';
import { useReportFrameNestedScroll } from '../../../Frame/context';
export const useMessageListScrollShadow = (isCenteredEmpty, t0) => {
  const $ = _c(11);
  const syncFrameScrollShadow = t0 === undefined ? false : t0;
  const [isScrolled, setIsScrolled] = useState(false);
  const messageListRef = useRef(null);
  const reportFrameNestedScroll = useReportFrameNestedScroll();
  let t1;
  if ($[0] !== reportFrameNestedScroll || $[1] !== syncFrameScrollShadow) {
    t1 = () => {
      if (messageListRef.current == null) {
        return;
      }
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = messageListRef.current;
      const isNotAtBottom = scrollTop + clientHeight < scrollHeight - 1;
      setIsScrolled(isNotAtBottom);
      if (syncFrameScrollShadow) {
        reportFrameNestedScroll?.(scrollTop > 0);
      }
    };
    $[0] = reportFrameNestedScroll;
    $[1] = syncFrameScrollShadow;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleScroll = t1;
  let t2;
  let t3;
  if ($[3] !== handleScroll || $[4] !== isCenteredEmpty || $[5] !== reportFrameNestedScroll || $[6] !== syncFrameScrollShadow) {
    t2 = () => {
      if (isCenteredEmpty) {
        setIsScrolled(false);
        if (syncFrameScrollShadow) {
          reportFrameNestedScroll?.(false);
        }
        return;
      }
      const element = messageListRef.current;
      if (element == null) {
        return;
      }
      element.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => {
        element.removeEventListener("scroll", handleScroll);
        if (syncFrameScrollShadow) {
          reportFrameNestedScroll?.(false);
        }
      };
    };
    t3 = [handleScroll, isCenteredEmpty, reportFrameNestedScroll, syncFrameScrollShadow];
    $[3] = handleScroll;
    $[4] = isCenteredEmpty;
    $[5] = reportFrameNestedScroll;
    $[6] = syncFrameScrollShadow;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== isScrolled) {
    t4 = {
      isScrolled,
      messageListRef
    };
    $[9] = isScrolled;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};